import * as publicApi from "../../../../service/publicApi";
import { environment } from "../../../../config.env";
const ENDPOINT_MOHPROMT = environment.mohpromt_url || "";
const ENDPOINT_MOHPROMT_CLIENT_ID = environment.mohpromt_client_id || "";
const ENDPOINT_HEALTH_ID = environment.health_id_url || "";
const ENDPOINT_HEALTH_ID_CLIENT_ID = environment.health_id_client_id || "";
const ENDPOINT_PROVIDER_ID = environment.provider_id_url || "";
const ENDPOINT_PROVIDER_ID_CLIENT_ID = environment.provider_id_client_id || "";
const REDIRECT_DOMAIN = environment.redirect_domain || "";

export const clickGetOauthUrl = async (userType) => {
  try {
    if (!userType) return "กรุณาเลือกประเภทของผู้เข้าใช้งาน";

    let res = await publicApi.getOauthUrlThaiID(userType);
    if (res) {
      if (res["data"]["code"] === 200) {
        setTimeout(() => {
          window.open(res["data"]["auth_url"], "_blank");
        }, 0);
      } else {
        return res["data"]["message_th"] || res["data"]["message"];
      }
    }
  } catch (error) {
    console.error("Error oauth url catch");
  }
};

export const clickGetLoginMohPromtp = async (userType) => {
  if (!userType) return "กรุณาเลือกประเภทของผู้เข้าใช้งาน";

  window.open(
    `${ENDPOINT_MOHPROMT}/oauth/redirect?client_id=${ENDPOINT_MOHPROMT_CLIENT_ID}&redirect_uri=${REDIRECT_DOMAIN}/loginMohPromt/${userType}&response_type=code`,
    "_system",
  );
};

export const clickGetLoginHealthID = () => {

  window.open(
    `${ENDPOINT_HEALTH_ID}/oauth/redirect?client_id=${ENDPOINT_HEALTH_ID_CLIENT_ID}&redirect_uri=${REDIRECT_DOMAIN}/loginHealthID&response_type=code`,
    "_system",
  );
};

export const clickGetLoginProviderID = async (userType) => {
  if (!userType) return "กรุณาเลือกประเภทของผู้เข้าใช้งาน";

  sessionStorage.setItem("provider_id_user_type", userType);
  window.open(
    `${ENDPOINT_PROVIDER_ID}/v1/oauth2/authorize?client_id=${ENDPOINT_PROVIDER_ID_CLIENT_ID}&redirect_uri=${REDIRECT_DOMAIN}/loginProviderID&response_type=code`,
    "_system",
  );
};
